import {
  afterAddToCart,
  getSectionsToFetch,
  refreshCartPage,
  reloadProductRecommendations,
  startLoadingStateForSubmitButtons,
  stopLoadingStateForSubmitButtons,
} from './cart-helper';

if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    static get observedAttributes() {
      return ['data-config'];
    }

    attributeChangedCallback() {
      this.setConfig();
    }

    connectedCallback() {
      if (!this.isConnected) return;

      this.setConfig();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    setConfig() {
      this.config = parseJson(this.getAttribute('data-config') || '{}');
    }

    async onSubmitHandler(evt) {
      evt?.preventDefault();
      const { shortSaleShippingMin, shortSaleShippingMax } = this.config;

      // put the default atc button into an array of buttons
      startLoadingStateForSubmitButtons();

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const sectionsToFetch = getSectionsToFetch();

      const formData = new FormData(this.form);
      formData.append('sections', sectionsToFetch);
      formData.append('sections_url', window.location.pathname);

      if (shortSaleShippingMin && shortSaleShippingMax) {
        formData.append('properties[_Short Sale Shipping Minimum]', shortSaleShippingMin);
        formData.append('properties[_Short Sale Shipping Maximum]', shortSaleShippingMax);
      }

      config.body = formData;

      const variant_id = formData.get('id');
      const warranty_block = document.querySelector(
        `warranty-block[data-variant-id="${variant_id}"]`
      );

      try {
        const response = await fetch(`${routes.cart_add_url}`, config);
        const parsedState = await response.json();

        afterAddToCart({
          response: parsedState,
          quantity: formData.get('inventory_quantity'),
        });
        this.refreshRelatedElements();
        if (warranty_block) {
          await warranty_block.onAddToCart();
        }
      } catch (error) {
        console.error(error);
      } finally {
        stopLoadingStateForSubmitButtons();
      }
    }

    refreshRelatedElements() {
      reloadProductRecommendations();

      const cartItems = document.querySelector('cart-items');
      if (!cartItems) return;

      refreshCartPage();
    }
  }

  window.ProductForm = ProductForm;
  customElements.define('product-form', ProductForm);
}
